import axios from "axios";
import React, { useEffect, useRef, useState } from "react";
import { Modal } from "react-bootstrap";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";

const AddComboOrderModal = ({ PlatformSingleData, handleCloseAddComboOrderAdd, setResults }) => {
  const { id } = useParams();

  const [platformTypeData, setPlatformTypeData] = useState([]);
  const [productData, setProductData] = useState([]);

  const [platformType, setPlatformType] = useState(
    PlatformSingleData?.platformTypeId?._id || ""
  );

  // Initially empty
  const [profit, setProfit] = useState("");
  const [products, setProducts] = useState([]);

  const [errorMessage, setErrorMessage] = useState({});
  const refSubmitDis = useRef(null);

  // Update platform when PlatformSingleData changes
  useEffect(() => {
    setPlatformType(PlatformSingleData?.platformTypeId?._id || "");
  }, [PlatformSingleData]);

  // Fetch Platform Types
  useEffect(() => {
    const fetchPlatformTypes = async () => {
      try {
        const response = await axios.get(
          "https://api.velormall.com/api/admin/platform-type/all/view"
        );

        setPlatformTypeData(response?.data?.data || []);
      } catch (error) {
        toast.error("Failed to load platforms");
      }
    };

    fetchPlatformTypes();
  }, []);

  // Fetch Products
  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const response = await axios.get(
          "https://api.velormall.com/api/admin/product/all/view"
        );

        setProductData(response?.data?.data || []);
      } catch (error) {
        toast.error("Failed to load products");
      }
    };

    fetchProducts();
  }, []);

  // Add Product
  const handleAddProduct = () => {
    setProducts((prev) => [
      ...prev,
      {
        rowId: `${Date.now()}-${Math.random()}`,
        productId: "",
        price: "",
        quantity: "1",
      },
    ]);

    setErrorMessage({});
  };

  // Remove Product
  const handleRemoveProduct = (rowId) => {
    setProducts((prev) => prev.filter((item) => item.rowId !== rowId));
  };

  // Select Product
  const handleProductChange = (rowId, productId) => {
    const selectedProduct = productData.find(
      (item) => item._id === productId
    );

    setProducts((prev) =>
      prev.map((item) =>
        item.rowId === rowId
          ? {
            ...item,
            productId,
            price: selectedProduct
              ? String(selectedProduct.price ?? "")
              : "",
          }
          : item
      )
    );

    setErrorMessage({});
  };

  // Change Quantity
  const handleQuantityChange = (rowId, quantity) => {
    setProducts((prev) =>
      prev.map((item) =>
        item.rowId === rowId
          ? { ...item, quantity }
          : item
      )
    );
  };

  // Calculate Subtotal
  const subtotal = products.reduce((total, item) => {
    if (
      !item.productId ||
      item.price === "" ||
      item.quantity === ""
    ) {
      return total;
    }

    const price = Number(item.price);
    const quantity = Number(item.quantity);

    if (
      !Number.isFinite(price) ||
      !Number.isFinite(quantity) ||
      price < 0 ||
      quantity < 1
    ) {
      return total;
    }

    return total + price * quantity;
  }, 0);

  // Validate Profit
  const validProfit =
    profit !== "" &&
    Number.isFinite(Number(profit)) &&
    Number(profit) >= 0;

  // Calculate Expected Income
  const profitAmount = validProfit
    ? (subtotal * Number(profit)) / 100
    : 0;

  const expectedIncome = validProfit
    ? subtotal + profitAmount
    : "";

  // Submit Combo Order
  const handleSubmitData = async (event) => {
    event.preventDefault();
    setErrorMessage({});

    if (refSubmitDis.current) {
      refSubmitDis.current.disabled = true;
    }

    try {
      // const calculatedSubtotal = Number(subtotal.toFixed(2));
      // const calculatedProfitAmount =
      //   (calculatedSubtotal * Number(profit)) / 100;

      // const calculatedExpectedIncome =
      //   calculatedSubtotal + calculatedProfitAmount;

      // const payload = {
      //   platformTypeId: platformType,
      //   profit: Number(profit),

      //   products: products.map((item) => ({
      //     productId: item.productId,
      //     price: Number(item.price),
      //     quantity: Number(item.quantity),
      //     amount: Number(
      //       (Number(item.price) * Number(item.quantity)).toFixed(2)
      //     ),
      //   })),

      //   subtotal: calculatedSubtotal,
      //   profitAmount: Number(calculatedProfitAmount.toFixed(2)),
      //   totalWithProfit: Number(calculatedExpectedIncome.toFixed(2)),
      // };


      const payload = {
        type: "Combo",
        orderSetId: id,
        platformTypeId: platformType,
        profit: Number(profit),
        products: products.map((item) => ({
          productId: item?.productId,
          quantity: Number(item?.quantity),
        })),
      };


      // // Change this URL if your backend uses another combo-order endpoint.
      const response = await axios.post(
        "https://api.velormall.com/api/admin/order/create",
        payload,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (response?.data?.success) {
        setResults(response?.data);
        handleCloseAddComboOrderAdd();
        toast.success(response?.data?.message);
        setProducts([]);
        setProfit("");
        setErrorMessage({});
      } else {
        setErrorMessage(response?.data?.errors || {});
        // toast.error(response?.data?.message);
      }
    } catch (error) {
      // console.log(error?.response?.data?.errors)
      setErrorMessage(error?.response?.data?.errors || {});
      // toast.error(error?.response?.data?.message);
    } finally {
      if (refSubmitDis.current) {
        refSubmitDis.current.disabled = false;
      }
    }
  };

  return (
    <Modal.Body>
      <form onSubmit={handleSubmitData}>
        <div className="modal-body">
          {/* Select Platform */}
          <div className="form-group mb-3">
            <label htmlFor="platformType" className="required">
              Select Platform
            </label>

            <select
              className="form-control"
              name="platformTypeId"
              id="platformType"
              value={platformType}
              onChange={(e) => setPlatformType(e.target.value)}
            >
              <option value="">Select Platform</option>

              {platformTypeData.map((item) => (
                <option key={item._id} value={item._id}>
                  {item.name}
                </option>
              ))}
            </select>

            {errorMessage?.platformTypeId && (
              <span className="text-danger pt-2">
                {errorMessage.platformTypeId.msg}
              </span>
            )}
          </div>

          {/* Add Product + Profit */}
          <div className="row mb-4">
            <div className="col-md-6 mb-2">
              <label className="d-block">&nbsp;</label>

              <button
                type="button"
                className="btn btn-outline-primary w-100"
                onClick={handleAddProduct}
              >
                + Add Product
              </button>
              {errorMessage?.products && (
                <span className="text-danger pt-2">
                  {errorMessage.products.msg}
                </span>
              )}
            </div>

            <div className="col-md-6 mb-2">
              <label htmlFor="profit" className="required">
                Profit %
              </label>

              <input
                type="number"
                className="form-control"
                name="profit"
                id="profit"
                placeholder="Profit %"
                value={profit}
                onChange={(e) => setProfit(e.target.value)}
                min="0"
                step="any"
              />

              {errorMessage?.profit && (
                <span className="text-danger pt-2">
                  {errorMessage.profit.msg}
                </span>
              )}
            </div>
          </div>

          {/* Product Rows */}
          {products.map((item, index) => (
            <div
              className="row align-items-end mb-3"
              key={item.rowId}
            >
              {/* Manage Product */}
              <div className="col-md-5 col-12 mb-2">
                <label
                  htmlFor={`product-${item.rowId}`}
                  className="required"
                >
                  Manage Product {index + 1}
                </label>

                <select
                  className="form-control"
                  id={`product-${item.rowId}`}
                  value={item.productId}
                  onChange={(e) =>
                    handleProductChange(item.rowId, e.target.value)
                  }
                >
                  <option value="">Select Product</option>

                  {productData.map((product) => (
                    <option key={product?._id} value={product?._id}>
                      {product?.name}
                    </option>
                  ))}
                </select>
                {errorMessage?.[`products[${index}].productId`]?.msg && (
                  <span className="text-danger pt-2">
                    {errorMessage[`products[${index}].productId`].msg}
                  </span>
                )}
              </div>

              {/* Price */}
              <div className="col-md-3 col-6 mb-2">
                <label htmlFor={`price-${item.rowId}`}>
                  Price
                </label>

                <input
                  type="number"
                  className="form-control"
                  id={`price-${item.rowId}`}
                  value={item.productId ? item.price : ""}
                  placeholder="Price"
                  readOnly
                />
              </div>

              {/* Quantity */}
              <div className="col-md-3 col-5 mb-2">
                <label
                  htmlFor={`quantity-${item.rowId}`}
                  className="required"
                >
                  Quantity
                </label>

                <input
                  type="number"
                  className="form-control"
                  id={`quantity-${item.rowId}`}
                  value={item.productId ? item.quantity : ""}
                  onChange={(e) =>
                    handleQuantityChange(item.rowId, e.target.value)
                  }
                  min="1"
                  step="1"
                />
                {errorMessage?.[`products[${index}].quantity`]?.msg && (
                  <span className="text-danger pt-2">
                    {errorMessage[`products[${index}].quantity`].msg}
                  </span>
                )}
              </div>

              {/* Remove Product */}
              <div className="col-md-1 col-1 mb-2">
                <button
                  type="button"
                  className="btn btn-outline-danger"
                  title="Remove product"
                  onClick={() => handleRemoveProduct(item.rowId)}
                >
                  ×
                </button>
              </div>
            </div>
          ))}

          {/* Subtotal + Expected Income: Bottom Right */}
          <div className="row mt-4">
            <div className="col-md-6 ms-auto">
              <div className="border rounded p-3">
                <div className="d-flex justify-content-between mb-2">
                  <span>Subtotal:</span>
                  <strong>${subtotal.toFixed(2)}</strong>
                </div>

                <div className="d-flex justify-content-between">
                  <strong>Expected Income:</strong>

                  <strong className="text-success">
                    {expectedIncome === ""
                      ? "—"
                      : `$${Number(expectedIncome).toFixed(2)}`}
                  </strong>
                </div>
              </div>
            </div>
          </div>

          {/* Submit */}
          <button
            type="submit"
            ref={refSubmitDis}
            className="btn btn-primary w-100 h-45 mt-3"
          >
            Submit Combo Order
          </button>
        </div>
      </form>
    </Modal.Body>
  );
};

export default AddComboOrderModal;